    <div class="twk-row">
      <div class="twk-lbl"><span>{{ label() }}</span></div>
      <div role="radiogroup" class="twk-seg">
        <div class="twk-seg-thumb"
             [style.left]="'calc(2px + ' + activeIndex() + ' * (100% - 4px) / ' + options().length + ')'"
             [style.width]="'calc((100% - 4px) / ' + options().length + ')'"></div>
        @for (o of options(); track o) {
          <button type="button" role="radio" [attr.aria-checked]="o === value()" (click)="select(o)">{{ o }}</button>
        }
      </div>
    </div>
